export type UserRole = 'admin' | 'manager' | 'user' | 'unknown';
export const userRoleList: UserRole[] = ['admin', 'manager', 'user'];
export const userRoleKr: Record<UserRole, string> = {
  admin: '관리자',
  manager: '매니저',
  user: '일반 사용자',
  unknown: '알 수 없음',
};

export const userStatusKr: Record<string, string> = {
  active: '🟢 활성',
  inactive: '🔴 비활성',
  deleted: '⚫️ 삭제',
};

/**
 * 서비스 버전 라벨.
 * - serviceVersion === 2 → v2
 * - 그 외(undefined 포함) → v1
 * 모든 콘솔 화면에서 v1/v2 배지·필터·카운트 라벨로 통일해서 사용.
 */
export type ServiceVersionLabel = 'v1' | 'v2';

export const getServiceVersionLabel = (serviceVersion: number | undefined): ServiceVersionLabel =>
  serviceVersion === 2 ? 'v2' : 'v1';

export const formatServiceVersionGroupCount = (v1Count: number, v2Count: number): string =>
  `v1: ${v1Count}명 / v2: ${v2Count}명`;

/**
 * 발송/필터 화면에서 v1/v2 분리 카운트를 계산.
 * `serviceVersion === 2`만 v2, 그 외(undefined 포함)는 v1으로 분류.
 */
export const countByServiceVersion = (users: { serviceVersion?: number }[]): Record<ServiceVersionLabel, number> => {
  const v2 = users.filter((user) => user.serviceVersion === 2).length;
  return { v1: users.length - v2, v2 };
};

/**
 * 화면 상단 v1/v2 토글 필터 옵션.
 * Segmented / Radio.Group `options` prop에 그대로 사용.
 */
export type ServiceVersionFilter = 'all' | ServiceVersionLabel;

export const serviceVersionFilterOptions: { label: string; value: ServiceVersionFilter }[] = [
  { label: '전체', value: 'all' },
  { label: 'v1', value: 'v1' },
  { label: 'v2', value: 'v2' },
];

export const matchesServiceVersionFilter = (
  serviceVersion: number | undefined,
  filter: ServiceVersionFilter,
): boolean => filter === 'all' || getServiceVersionLabel(serviceVersion) === filter;
